export default __webpack_public_path__ + "static/footer-desktop@2x-ca9628d829a5b7fcb4e1af5aafff3480.jpg";